import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FiChevronUp, FiBookOpen } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import { GiHamburgerMenu } from "react-icons/gi";
import { GoRocket } from "react-icons/go";
import {FiMail , FiSmartphone, FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo} from "react-icons/fi";
import { FaGraduationCap, FaWhatsapp, FaCalendarCheck, FaRunning, FaFacebookSquare, FaStar } from "react-icons/fa";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TestimonialOne, {TestimonialOneDataScience} from "../blocks/testimonial/TestimonialOne";



class LandingTestimonial extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          Email: '',
          langUS: false,
        }

        this.openModal = this.openModal.bind(this)
        this.onSubmit = this.onSubmit.bind(this);
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    onSubmit(e) {
        e.preventDefault();
        // this.setState({isOpenEmail: !this.state.isOpenEmail});
        // this.openModalCheckout();
        
        if(this.state.Email == ""){
            return;
        }

        toast.success("Te enviaremos el Ebook por Email pronto, gracias!");

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {type_email: 'ebook', email: this.state.Email, name: this.state.Name, phone: this.state.Phone, country: this.state.countryCode},)
        .then(res => {
            console.log('ok sent')
        })
    }


    openModal () {
        this.setState({isOpen: true})
    }

    OpenWS(){
        if (window.type_device){
            window.open("https://api.whatsapp.com/send?phone=51936670597&text=Hola%20Dojopy%2C%20informes%20sobre%20el%20BootCamp%20FullStack.%20" + this.state.grupoSelect, '_blank').focus();
        } else {
            window.open("https://web.whatsapp.com/send?phone=51936670597&text=Hola%20Dojopy%2C%20informes%20sobre%20el%20BootCamp%20FullStack.%20" + this.state.grupoSelect, '_blank').focus();
        }
    }

    OpenMeet(){
        window.open("https://calendly.com/dojopy/bootcamp-full-stack", '_blank').focus();
    }
    render(){
        return(
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Testimonios Bootcamp' urlSeo="/testimonios" />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--130 pb--50 bg_image bg_image--27"  data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center">
                                    <h3 style={{color: 'white'}} className="title pb-1">

                                        {this.state.langUS ?
                                        "What Our Students Share: Their Stories and Opinions" :
                                        "Lo Que Nuestros Alumnos Comparten: Sus Historias y Opiniones"
                                        }
                                    </h3>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}




                <>
                 <div style={{marginTop: "20px"}} className="section-title service-style--3 text-center mb--25 mb_sm--0 text-center">
                    <h2 className="title">{this.state.langUS ? "Testimonials ": "Testimonios"} </h2>
                </div>

                <div className="rn-testimonial-area bg_color--1 ptb--80">
                    <div className="container">
                        <TestimonialOne langUS={this.state.langUS} />
                        {/* <TestimonialOneDataScience/> */}
                    </div>
                </div>
    </>



  {/* Start About Area */}
  {!this.state.langUS &&
  <div className="about-area ptb--70 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            
                            <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Judith</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/alN6nU5a2Vo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Bladimir</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/dDPWdY-S8-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Tatiana</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/NhOFeo9_rA4?si=_LWhcwSgAOlmF0Od" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Harold Ivan</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/CJWjmlO3_7k?si=0VWDgUmLhp4pyNRg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Stephany</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/330Wxw_z4_0?si=Ms_tnorjQRspKGrw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Ricardo Osorio</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/ZaR2-71Kg9Q?si=pz_7oW3sL6gOP2oG" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Diana</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/gpLkbRA4ZrE?si=UV0v9lnJQn2IdwAA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                            <h3 className="title">Testimonio Paul</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/81xtrnKV9Ss" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}


{/* 
                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Oscar</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/qtu4qNnBZbI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Andrés</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/Xxif1Dc_ifQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}




                            </div>
                        </div>
                    </div>
                </div>
}
                {/* End About Area */}





  <div className="about-area ptb--50 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container px-0" style={{width: "90%"}}>
                        



{!this.state.langUS &&
<div style={{backgroundColor: "white", padding: "0", textAlign: "left"}}>







<div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/dojopy/019209102.png" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Javier L.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Como estudiante de informática, sentía que me faltaba experiencia práctica para destacar en el mercado laboral. Gracias al bootcamp, pude desarrollar proyectos reales y adquirir habilidades actuales que no enseñan en la universidad. Ahora, mientras termino mis estudios, ya trabajo como Full Stack Developer en una empresa de tecnología, ganando más de $4,000/mes. ¡El bootcamp fue el complemento perfecto para mi carrera!"

      <br/>
      <b>
      – Javier L., estudiante de informática y desarrollador en una empresa de tecnología.

      </b>
      </p>
    </div>
  </div>

  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_3.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Bladimir G.
        <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>
        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
      
      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Decidí inscribirme en el Bootcamp y fue la mejor decisión de mi vida. Ahora tengo la oportunidad de trabajar con importantes empresas y mis ingresos han mejorado significativamente ¡Gracias Dojofullstack, por brindarme una educación de calidad!"
      <br/>
      <b>
         – Bladimir G., ex principiante y ahora Developer en una empresa internacional.
      </b>
      </p>
    </div>
  </div>


  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_4.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Victor R.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Cuando seguí esta ruta, pasé de vender ropa en línea a ganar $3,000/mes como Developer Full Stack."
      <br/>
      <b>
         – Victor R., ex principiante y ahora Developer en una empresa internacional.
      </b>
      </p>
    </div>
  </div>





  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_1.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Laura M.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Soy mamá de dos niños y trabajaba como profesora de primaria.
A los 30 años, pensé que era tarde para cambiar de carrera…
¡Hoy trabajo como Full Stack Developer para una empresa alemana
y gano $3,800/mes desde casa! Lo mejor: veo crecer a mis hijos
mientras diseño aplicaciones educativas que usan miles de alumnos."

      <br/>
      <b>
         – Laura M., egresada del programa en 10 meses.

      </b>
      </p>
    </div>
  </div>



  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/dojopy/01920912.png" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Maria Sanchez
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      Siempre pensé que una carrera en tecnología estaba fuera de mi alcance. Sin embargo, el bootcamp no solo me enseñó habilidades técnicas, sino también cómo aplicarlas en el mundo real. Ahora trabajo para una empresa de tecnología educativa y gano más de $2,300/mes. Lo mejor es que puedo trabajar remotamente y pasar tiempo de calidad con mi hijo.

      <br/>
      <b>
         – Maria Sanchez., egresada del programa en 10 meses.

      </b>
      </p>
    </div>
  </div>
  </div>
  }

{this.state.langUS &&

   <>


                <div className="rn-testimonial-area bg_color--1 ptb--80">
                    <div className="container">
    
                        <div className="mt-3" style={{backgroundColor: "white", padding: "0", textAlign: "left"}}>
                  

                        <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                            <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/019209102.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Nathan Collins
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                 
<p style={{fontSize: "11px", fontStyle: "italic"}}>
    "As a computer science student, I felt I lacked practical experience to stand out in the job market. Thanks to the bootcamp, I was able to develop real projects and acquire current skills that aren't taught in university. Now, while finishing my studies, I'm already working as a Full Stack Developer at a tech company, earning more than $7,500/month. The bootcamp was the perfect complement to my career!"

    <br/>
    <b>
   Nathan Collins
 – , computer science student and Developer at a tech company.
    </b>
</p>

                            </div>
                          </div>
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_3.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Logan Carter
                                <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                              
                          <p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I decided to enroll in the Full Stack Developer bootcamp and it was the best decision of my life. Now I have the opportunity to work with major companies and my income has improved significantly. Thank you Dojofullstack, for providing me with quality education!"
   <br/>
   <b>
      – Logan Carter, former beginner and now Developer at an international company.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_4.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Ethan Walker
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                         <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "When I followed this path, I went from selling clothes online to earning $8,000/month as a Full Stack Developer."
   <br/>
   <b>
      – Ethan Walker, former beginner and now Developer at an international company.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_1.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Lily Matthews
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                           <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I'm a mother of two children and worked as an elementary school teacher.
At 30, I thought it was too late to change careers…
Today I work as a Full Stack Developer for a German company
and earn $6,800/month from home! The best part: I watch my children grow
while designing educational applications used by thousands of students."

   <br/>
   <b>
     Lily Matthews – , program graduate in 4 months.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/01920912.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Emily Parker
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                        <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I always thought a career in technology was out of my reach. However, the bootcamp not only taught me technical skills, but also how to apply them in the real world. Now I work for an educational technology company and earn more than $6,300/month. The best part is that I can work remotely and spend quality time with my son."

   <br/>
   <b>
     Emily Parker – ., program graduate in 4 months.
   </b>
</p>
                            </div>
                          </div>
                          
                          
                             <div className="mt-4 text-center">
                    {/* <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/truspilot.png" /> */}
                    <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/dojofullstack_report.png" />
                    <span style={{display: "inline-block", marginLeft: "5px", color: "white", "font-size": "13px", "paddingTop": "20px", fontStyle: "italic"}}>  
                   Guaranteed Excellence in Training
                    </span>
                    </div>

                          </div>
              


                    </div>


                    
                </div>
    </>
}





                        </div>
                    </div>
                </div>


                    {/* Start Team Area  */}
  <div className="rn-team-area ptb--100 bg_color--1" id="team" data-aos="fade-right" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title service-style--3 text-center mb--25 mb_sm--0">
                                        <h2 className="title">
                                            {this.state.langUS ?
                                            " Join our Full Stack Bootcamp and start your career in technology today!":
                                            " ¡Únete a nuestro Bootcamp Full Stack y comienza tu carrera en tecnología hoy mismo!"
                                            }
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3" style={{justifyContent: "center"}}>
                                <a className="rn-btn" href={this.state.langUS ? "/us": "/"} style={{fontSize: "18px", padding: "8px"}}  >
                                <GoRocket style={{fontSize: "18px", marginRight: "10px"}}/>
                                    {this.state.langUS ? "Visit Bootcamp" : "Visitar Bootcamp"}
                                </a>
                            </div>
                        </div>
                </div>
                {/* End Team Area  */}



              
                <ToastContainer
                                                    position="bottom-center"
                                                    autoClose={5000}
                                                    />
              

                {/* Start Back To Top */}
                {/* <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div> */}
                {/* End Back To Top */}


                <FooterTwo />

            </React.Fragment>
        )
    }

    async componentDidMount() {

        if (window.location.pathname.includes("testimonials")) {
            this.setState({langUS: true});
        }
    

    }
}
export default LandingTestimonial;
